const listaDeRotas = (state) => {
    return state.items;
}

const processandoRota = (state) => {
    return state.buscando
}

const listaDeSubmodulos = (state) => {
    return state.submodulos;
}

const loadingRotas = (state) => {
    return state.buscando
}

export {
    listaDeRotas,
    processandoRota,
    listaDeSubmodulos,
    loadingRotas
}